import graphql from "babel-plugin-relay/macro";
import { PreloadedQuery, usePreloadedQuery } from "react-relay";

import { BookingList } from "./BookingList";
import { BookingHistoryQuery } from "./__generated__/BookingHistoryQuery.graphql";

type BookingHistoryProps = {
  queryRef: PreloadedQuery<BookingHistoryQuery>;
  setPageCursor: (cursor: string | null) => void;
};

export const BookingHistory = ({
  queryRef,
  setPageCursor,
}: BookingHistoryProps) => {
  const data = usePreloadedQuery(BookingHistoryQueryString, queryRef);
  const member = data.session?.currentClientProfile?.member;

  return member ? (
    <BookingList
      fragmentRef={data.session?.currentClientProfile.member}
      setPageCursor={setPageCursor}
    />
  ) : null;
};

export const BookingHistoryQueryString = graphql`
  query BookingHistoryQuery($dateGTE: Date!, $first: Int!, $after: String) {
    session {
      currentClientProfile {
        member {
          club {
            name
          }
          clientClass
          ...BookingList_Client
        }
      }
    }
  }
`;
